import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import GSTReportPageUI from './GSTReportPageUI.js'

class GSTReportPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      gstReportList: [],
      gstReportMonthlyList: []
    }
  }

  render() {
    return (
      <GSTReportPageUI
        context={this.props.context}
        account={this.state.account}
        gstReportList={this.state.gstReportList}
        gstReportMonthlyList={this.state.gstReportMonthlyList}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getGSTReport(context)
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  getGSTReport(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/gstReport`,
      cacheKey: CacheKeys.GSTReport(this.props.match.params.accountId),
      callback: this.getGSTReportCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getGSTReportCallback = (response) => {
    this.setState(
      {
        gstReportList: response.gstReports,
        gstReportMonthlyList: []
      }, () => {
        let gstNumberList = Array.from(new Set(response.gstReports.map(g => g.gstin)))
        gstNumberList.map((gstNumber) =>
          this.getGSTReportMonthly(this.props.context, gstNumber)
        )
      }
    )
  }

  getGSTReportMonthly(context, gstNumber) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/gstReport/${gstNumber}/monthly`,
      cacheKey: CacheKeys.GSTReportMonthly(this.props.match.params.accountId, gstNumber),
      callback: this.getGSTReportMonthlyCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

 getGSTReportMonthlyCallback = (response) => {
    const incoming = response.gstReportMonthlyList || []
    const incomingGstins = incoming.map(r => r.gstin)
    this.setState((prevState) => ({
      gstReportMonthlyList: prevState.gstReportMonthlyList
        .filter(r => incomingGstins.indexOf(r.gstin) === -1)
        .concat(incoming)
    }))
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.GSTReport(this.props.match.params.accountId))
    this.setState({ gstReportList: null, gstReportMonthlyList: [] },
      this.getGSTReport(this.props.context)
    )
  }
}

export default withRouter(GSTReportPageSF)
